import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../_client-service/menu/menu.service';
import { UserService } from 'src/app/service/user.service';
import { first } from 'rxjs/operators';
import { User } from 'src/app/model/user';
import { UserSessionService } from 'src/app/_client-service/user-session.service';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrls: ['./platform.component.css']
})
export class PlatformComponent implements OnInit {

    user: User;
    menuStatus: string;

    constructor(
        private userSessionSrv: UserSessionService,
        private userSrv: UserService,
        private menuSrv: MenuService) { }

    ngOnInit() {
        this.getUser();
        this.menuSrv.onToggleButton.subscribe(menuStatus => this.menuStatus = menuStatus);
    }

    // private toggleMemu(menuStatus: string) {
    //     alert(menuStatus);
    // }

    private getUser() {
        this.userSrv.getUser()
        .pipe(first())
        .subscribe(
            data => {
                this.user = data;
                this.userSessionSrv.setUser(data);
            },
            error => {
                return;
            }
        );
    }

}
